var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"client-avatar",attrs:{"src":_vm.url || _vm.$avatar,"alt":"selfie do cliente"}})}
var staticRenderFns = []

export { render, staticRenderFns }